import React from 'react';
import PropTypes from 'prop-types';
import  {
    Animated,
    TextInput,
    TouchableWithoutFeedback,
    View,
    StyleSheet,
    TouchableOpacity, I18nManager, Platform
} from 'react-native';

import BaseInput from './BaseInput';
import {moderateScale} from "../../tools/Scaling";

import i18n from "../../I18n/i18n";
import {typeExport} from "../../redux/store/type";

export default class CostumeFumi extends BaseInput {
    static propTypes = {
        /*
         * This is the icon component you are importing from react-native-vector-icons.
         * import FontAwesomeIcon from 'react-native-vector-icons/FontAwesome';
         * iconClass={FontAwesomeIcon}
         */
        iconClass: PropTypes.func.isRequired,
        /*
         * Passed to react-native-vector-icons library as name prop
         */
        iconName: PropTypes.string.isRequired,
        /*
         * Passed to react-native-vector-icons library as color prop.
         * Also used as textInput color.
         */
        iconColor: PropTypes.string,
        /*
         * Passed to react-native-vector-icons library as size prop.
         */
        iconSize: PropTypes.number,

        passiveIconColor: PropTypes.string,
        height: PropTypes.number,
    };

    static defaultProps = {
        height: moderateScale(60),
        iconColor: '#00aeef',
        iconSize: moderateScale(20),
        iconWidth: moderateScale(40),
        inputPadding: moderateScale(7),
        passiveIconColor: '#a3a3a3',
        animationDuration: 300,
    };

    componentDidMount() {
        if (this.props.onRef != null) {
            this.props.onRef(this)
        }
    }

    onSubmitEditing() {
        this.props.onSubmitEditing();
    }

    render() {
        const {
            _ref,
            lengthWord,
            iconClass,
            iconColor,
            iconSize,
            passiveIconColor,
            iconName,
            label,
            style: containerStyle,
            containerInputStyle,
            inputStyle,
            height: inputHeight,
            inputPadding,
            iconWidth,
            labelStyle,
            placeholder,
            multiline,
            onSubmitEditing,
            returnKeyType,
            keyboardType,
            autoFocus,
            _scroll,
            refName,
            border,
            secureTextEntry

        } = this.props;
        const {focusedAnim, value} = this.state;
        const AnimatedIcon = Animated.createAnimatedComponent(iconClass);
        const ANIM_PATH = inputPadding + inputHeight;
        const NEGATIVE_ANIM_PATH = ANIM_PATH * -1;

        return (
            <Animated.View
                style={[styles.container, containerStyle,
                    border ? {
                        borderColor: focusedAnim.interpolate({
                            inputRange: [0, 0.5, 1],
                            outputRange: [passiveIconColor, iconColor, iconColor],
                        }),
                    } : {}, {
                        height: ANIM_PATH,
                    }]}
                onLayout={this._onLayout}
            >
                {/*    <TouchableWithoutFeedback style={{alignItems: 'center', justifyContent: 'center'}} onPress={this.focus}>
                    <AnimatedIcon
                        name={iconName}
                        color={iconColor}
                        size={iconSize}
                        style={{
                            position: 'absolute',
                            left: moderateScale(8),
                            bottom: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 0.51, 0.7, 1],
                                outputRange: [
                                    24,
                                    ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    24,
                                ],
                            }),
                            color: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 1],
                                outputRange: [passiveIconColor, iconColor, iconColor],
                            }),
                        }}
                    />
                </TouchableWithoutFeedback>
                <Animated.View
                    style={[
                        styles.separator,
                        {
                            height: inputHeight,
                            //left: iconWidth + moderateScale(1),
                            left: iconWidth - moderateScale(8),
                            backgroundColor: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 1],
                                outputRange: [passiveIconColor, iconColor, iconColor],
                            })
                        },
                    ]}
                />*/}
                <TouchableWithoutFeedback

                    onPress={this.focus}
                >
                    <Animated.View
                        style={{
                            position: 'absolute',

                            // left: iconWidth + inputPadding,
                            //  left: moderateScale(6),
                            left: inputPadding,
                            height: inputHeight,
                            top: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 0.51, 0.7, 1],
                                outputRange: [
                                    moderateScale(31),
                                    ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    inputPadding / 2,
                                ],
                            }),
                        }}
                    >
                        <Animated.Text
                            style={[
                                styles.label,
                                {
                                    fontSize: focusedAnim.interpolate({
                                        inputRange: [0, 0.7, 0.71, 1],
                                        outputRange: [moderateScale(12), moderateScale(12), moderateScale(11), moderateScale(11)],
                                    }),
                                    color: focusedAnim.interpolate({
                                        inputRange: [0, 0.7],
                                        outputRange: ['#a3a3a3', '#696969'],

                                    }),
                                    fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName
                                },
                                labelStyle,
                            ]}
                        >
                            {label}
                        </Animated.Text>
                    </Animated.View>
                </TouchableWithoutFeedback>
                <TouchableOpacity
                    onPress={() => {
                        this.focus()
                    }}
                    activeOpacity={1}>
                    <Animated.View
                        //pointerEvents="none"
                        style={[styles.containerInput, {
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(4),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1)
                        },
                            border ? {
                                borderColor: focusedAnim.interpolate({
                                    inputRange: [0, 0.5, 1],
                                    outputRange: [passiveIconColor, iconColor, iconColor],
                                }),
                            } : {}, {
                                height: ANIM_PATH - moderateScale(25),
                                marginTop: moderateScale(22)

                            }]}
                        //   onLayout={this._onLayout}
                    >
                        <TextInput
                            ref={this.input}
                            //  ref={this[`input${refName}`]}
                            //  ref={this[`input${refName}`]}

                            //  ref={ref}
                            {...this.props}
                            // ref={_ref}
                            //ref={ref}

                            style={[
                                styles.textInput,
                                {
                                    // marginLeft: inputPadding,
                                    // marginHorizontal: moderateScale(4),
                                    paddingLeft: inputPadding,
                                    paddingHorizontal: moderateScale(4),
                                    color: iconColor,
                                    fontSize: moderateScale(14),
                                    fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,
                                    textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',

                                },
                                inputStyle,
                            ]}
                            value={(value === null || value === "null" || value === undefined || value === "undefined" || value === "") ? null : String(value)}
                            // value={value}
                            onBlur={this._onBlur}
                            onFocus={this._onFocus}
                            onChange={this._onChange}
                            underlineColorAndroid={'transparent'}


                            //keyboardType={Platform.OS === "web" && !(navigator.userAgentData && navigator.userAgentData.mobile) ? "default" : keyboardType}



                            //  multiline={multiline ? true : false}
                            //   keyboardType={keyboardType ? keyboardType : "default"}
                            // placeholder={placeholder}
                            // onSubmitEditing={onSubmitEditing}
                            // onSubmitEditing={()=>this._onSubmitEditing(refName)}
                            //onSubmitEditing={()=>alert("")}
                            //  returnKeyType={ 'next'}
                            // autoFocus={autoFocus}


                            //  ref={ref}
                            //onFocus={onFocus}
                        />
                    </Animated.View>
                </TouchableOpacity>
            </Animated.View>
        );
    }
}

const styles = StyleSheet.create({
    container: {

        //  overflow: 'hidden',
        //  paddingTop: moderateScale(4),
        backgroundColor: 'white',

    },
    containerInput: {
        // overflow: 'hidden',
        //  paddingTop: moderateScale(4),
        //  backgroundColor: 'white',

    },
    label: {
        fontSize: moderateScale(14),
        fontWeight: 'bold',
    },
    textInput: {
        flex: 1,
        color: 'black',
        fontSize: moderateScale(14),
        padding: moderateScale(2),
        paddingLeft: 0,
        //  marginTop:moderateScale(25)
    },
    separator: {
        position: 'absolute',
        width: moderateScale(1),
        backgroundColor: '#f0f0f0',
        top: moderateScale(8),
    },
});
